<template>
    <v-card>
        <v-card-title>
            <v-btn small icon @click="close" color="primary" class="ml-n3 mr-2">
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <h2 class="font-weight-regular">
                Quality Process
            </h2>
        </v-card-title>
        <v-divider class="mx-6" />
        <v-card-text
            :style="{ 'max-height': `${height}px`, 'overflow-y': 'auto' }"
        >
            <v-form v-model="valid">
                <v-data-table
                    :headers="headers"
                    :items="filteredItems"
                    class="elevation-0 mt-7"
                    :mobile-breakpoint="0"
                    :loading="loading"
                    disable-pagination
                    hide-default-footer
                >
                    <template v-slot:top>
                        <v-row
                            no-gutter
                            class="mt-0 mx-0 pt-4 pb-0 pb-4"
                            :style="{ 'background-color': '#eeeeee' }"
                        >
                            <v-col cols="6" class="d-flex align-center">
                                <h2 class="my-n3 d-flex align-center">
                                    ITEMS
                                </h2></v-col
                            >
                        </v-row>
                    </template>
                    <template v-slot:[`header.partNumber`]="{ header }">
                        <v-text-field
                            :label="header.text"
                            v-model="partNumberToFilter"
                            dense
                            class="pt-2"
                        />
                    </template>
                    <!--ITEMS-->
                    <template v-slot:[`item.index`]="{ index }">
                        <p class="my-0">
                            {{ index + 1 }}
                        </p>
                    </template>
                    <template v-slot:[`item.code`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0">{{ item.code }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.description`]="{ item }">
                        <div>
                            <p class="my-0">{{ item.description }}</p>
                        </div>
                    </template>
                    <template v-slot:[`item.pending`]="{ item }">
                        <div class="d-flex justify-center">
                            <p class="my-0">
                                {{ item.pending }}
                            </p>
                        </div>
                    </template>
                    <template v-slot:[`item.reprocessQty`]="{ item }">
                        <div class="mb-5">
                            <v-text-field
                                v-model="item.reprocessQty"
                                type="text"
                                :rules="[() => maxValue(item)]"
                            />
                        </div>
                    </template>
                    <template v-slot:[`item.releaseQty`]="{ item }">
                        <div class="mb-5">
                            <v-text-field
                                v-model="item.releaseQty"
                                type="text"
                                :rules="[() => maxValue(item)]"
                            />
                        </div>
                    </template>
                    <template v-slot:[`item.rejectQty`]="{ item }">
                        <div class="mb-5">
                            <v-text-field
                                v-model="item.rejectQty"
                                type="text"
                                :rules="[() => maxValue(item)]"
                            />
                        </div>
                    </template>
                    <template v-slot:[`item.NCcode`]="{ item }">
                        <v-combobox
                            v-if="item.rejectQty"
                            v-model="item.NCcode"
                            :items="ncCodes"
                            hide-selected
                            required
                            flat
                            item-text="longName"
                            :rules="[rules.required]"
                            class="mt-n3"
                        />
                    </template>
                </v-data-table>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-simple-checkbox
                color="primary"
                v-model="setAvailableAsReleased"
                @click="setAllAvailableAsReleased"
                class="ml-2 d-flex justify-center align center"
            >
            </v-simple-checkbox>
            <small>Select All As Released</small>
            <v-spacer />
            <v-spacer />
            <v-btn
                :loading="loading"
                color="primary"
                rounded
                class="mb-3 mr-3"
                :disabled="disableButton()"
                @click="openConfirmDialog"
            >
                NEXT
            </v-btn>
        </v-card-actions>
        <!-- CONFIRM DIALOG -->
        <v-dialog
            :retain-focus="false"
            v-model="confirmDialog"
            persistent
            max-width="700px"
        >
            <v-card>
                <v-card-title>
                    <v-btn
                        small
                        icon
                        @click="closeConfirmDialog"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <h2 class="font-weight-regular">
                        Confirm Quality Process
                    </h2>
                </v-card-title>
                <v-divider class="mx-6" />
                <v-card-text>
                    <v-form v-model="valid">
                        <v-data-table
                            :headers="confirmHeaders"
                            :items="
                                items.filter(
                                    i =>
                                        (i.releaseQty && i.releaseQty > 0) ||
                                        (i.reprocessQty &&
                                            i.reprocessQty > 0) ||
                                        (i.rejectQty && i.rejectQty > 0)
                                )
                            "
                            class="elevation-0 mt-7"
                            :mobile-breakpoint="0"
                            :loading="loading"
                            disable-pagination
                            hide-default-footer
                            :style="{
                                'max-height': `${height}px`,
                                'overflow-y': 'auto',
                            }"
                        >
                            <template v-slot:top>
                                <v-row
                                    no-gutter
                                    class="mt-0 mx-0 pt-4 pb-0 pb-4"
                                    :style="{ 'background-color': '#eeeeee' }"
                                >
                                    <v-col
                                        cols="12"
                                        class="d-flex align-center"
                                    >
                                        <h2 class="my-n3 d-flex align-center">
                                            ITEMS
                                        </h2></v-col
                                    >
                                </v-row>
                            </template>
                            <!--ITEMS-->
                            <template v-slot:[`item.code`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.code }}</p>
                                </div>
                            </template>
                            <template v-slot:[`item.release`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.releaseQty }}</p>
                                </div>
                            </template>
                            <template v-slot:[`item.reprocess`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">
                                        {{ item.reprocessQty }}
                                    </p>
                                </div>
                            </template>
                            <template v-slot:[`item.reject`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">{{ item.rejectQty }}</p>
                                </div>
                            </template>
                            <template v-slot:[`item.NCcode`]="{ item }">
                                <div class="d-flex justify-center">
                                    <p class="my-0">
                                        {{
                                            item.NCcode
                                                ? getNCCode(item.NCcode).code
                                                : ''
                                        }}
                                    </p>
                                </div>
                            </template>
                        </v-data-table>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-0 pb-5">
                    <v-row class="ma-2">
                        <v-spacer />
                        <v-col cols="3" class="d-flex justify-end pa-0 ">
                            <v-btn
                                color="primary"
                                rounded
                                :disabled="!valid"
                                :loading="loading"
                                @click="registerQuality"
                            >
                                SAVE
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import { mapMutations } from 'vuex'
import _ from 'lodash'
import API from '@/services/api'

export default {
    name: 'MultipleQualityProcess',
    props: {
        workOrder: {
            type: Object,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        valid: false,
        loading: false,
        headers: [
            {
                text: 'ID',
                value: 'index',
                align: 'center',
                sortable: false,
                width: '50',
            },
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'DESCRIPTION',
                value: 'description',
                align: 'left',
                sortable: false,
            },
            {
                text: 'PENDING',
                value: 'pendingQty',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'RELEASE',
                value: 'releaseQty',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'REPROCESS',
                value: 'reprocessQty',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'REJECT',
                value: 'rejectQty',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'NC CODE',
                value: 'NCcode',
                align: 'center',
                sortable: false,
                width: '170',
            },
        ],
        confirmHeaders: [
            {
                text: 'PART NUMBER',
                value: 'partNumber',
                align: 'center',
                sortable: false,
            },
            {
                text: 'RELEASE',
                value: 'releaseQty',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'REPROCESS',
                value: 'reprocessQty',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'REJECT',
                value: 'rejectQty',
                align: 'center',
                sortable: false,
                width: '100',
            },
            {
                text: 'NC CODE',
                value: 'NCcode',
                align: 'center',
                sortable: false,
                width: '170',
            },
        ],
        rules: {
            required: v => !!v || 'The value is required',
        },
        height: 0,
        partNumberToFilter: undefined,
        items: [],
        confirmDialog: false,
        setAvailableAsReleased: false,
        ncCodes: [],
        qualityProcess: {
            id: 'quality',
            name: 'Quality',
        },
        settingProcessesId: '',
    }),
    computed: {
        filteredItems() {
            //filter available
            let conditions = []
            conditions.push(this.filterAvailable)
            if (this.partNumberToFilter) {
                conditions.push(this.filterForPartNumber)
            }
            if (conditions.length > 0) {
                return this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            return this.items
        },
    },
    async mounted() {
        this.items = []
        this.workOrder.items.forEach(item => {
            const copy = _.cloneDeep(item)
            this.calculateValues(copy)
            this.items.push(copy)
        })
        const {
            data: { settings },
        } = await API.getSettings()
        const settingProcesses = settings.find(
            setting => setting.name.toLowerCase() == 'processes'
        )
        if (settingProcesses) {
            this.settingProcessesId = settingProcesses.id
        }
        const setting = settings.find(
            setting => setting.name.toLowerCase() == 'quality'
        )
        this.ncCodes = setting.ncCodes
        this.ncCodes.forEach(code => {
            code.longName = code.description
                ? `${code.code} - (${code.description})`
                : `${code.code}`
        })
        this.onResize()
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        calculateValues(item) {
            try {
                item.pendingQty = 0
                let lastProcessIndex = item.processes.length - 1
                if (this.workOrder.assemblyWorkOrder != undefined) {
                    lastProcessIndex =
                        item.processes.findIndex(
                            p => p == this.qualityProcess.id
                        ) - 1
                }
                if (lastProcessIndex > -1) {
                    const lastProductionProcess =
                        item.processes[lastProcessIndex]
                    if (item.production) {
                        const production = item.production.filter(
                            entry => entry.process.id == lastProductionProcess
                        )
                        if (production.length > 0) {
                            item.pendingQty += production.reduce(
                                (accumulator, entry) => accumulator + entry.qty,
                                0
                            )
                        }
                    }
                    if (item.quality) {
                        const rejected = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.rejectQty || 0),
                            0
                        )
                        const released = item.quality.reduce(
                            (accumulator, entry) =>
                                accumulator + (entry.releaseQty || 0),
                            0
                        )
                        item.pendingQty -=
                            Number(released || 0) + Number(rejected || 0)
                    }
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            }
        },
        async registerQuality() {
            try {
                this.loading = true
                const filteredItems = this.items.filter(
                    i =>
                        i.releaseQty > 0 ||
                        i.reprocessQty > 0 ||
                        i.rejectQty > 0
                )

                if (filteredItems.length > 0) {
                    filteredItems.forEach(item => {
                        ;['releaseQty', 'reprocessQty', 'rejectQty'].forEach(
                            key => {
                                if (item[key]) {
                                    item[key] = Number(item[key])
                                }
                            }
                        )
                    })

                    const itemsToUpdate = filteredItems.map(fi => ({
                        partNumberId: fi.partNumberId,
                        releaseQty: fi.releaseQty,
                        reprocessQty: fi.reprocessQty,
                        rejectQty: fi.rejectQty,
                        NCcode: fi.NCcode ? fi.NCcode.id : undefined,
                    }))
                    await API.markBatchQuality({
                        items: itemsToUpdate,
                        workOrderId: this.workOrder.id,
                        settingId: this.settingProcessesId,
                    })
                    this.$emit('closeDialog')
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },

        openConfirmDialog() {
            this.confirmDialog = true
        },

        closeConfirmDialog() {
            this.confirmDialog = false
        },

        close() {
            this.$emit('closeDialog')
        },
        disableButton() {
            const hasQuantities = this.items.some(
                item =>
                    +item.releaseQty > 0 ||
                    +item.reprocessQty > 0 ||
                    +item.rejectQty > 0
            )

            const allRejectsHaveNC = this.items.every(item =>
                +item.rejectQty > 0 ? !!item.NCcode : true
            )

            const itemsValid = this.items.every(item => this.maxValue(item) === true);

            return !(hasQuantities && allRejectsHaveNC && itemsValid)
        },
        onResize() {
            this.height = window.innerHeight - 260
        },
        filterAvailable(item) {
            return item.pendingQty && item.pendingQty > 0
        },
        filterForPartNumber(item) {
            return (
                item.partNumber &&
                item.partNumber
                    .toLowerCase()
                    .includes(this.partNumberToFilter.toLowerCase())
            )
        },
        maxValue(item) {
            const keys = ['releaseQty', 'reprocessQty', 'rejectQty']

            for (const key of keys) {
                const value = item[key]

                if (value !== undefined && value !== null && value !== '') {
                    if (isNaN(Number(value))) {
                        return `invalid value`
                    }

                    if (Number(value) < 0) {
                        return `cannot be negative.`
                    }
                }
            }

            const total =
                Number(item.releaseQty || 0) +
                Number(item.reprocessQty || 0) +
                Number(item.rejectQty || 0)

            if (total > item.pendingQty) {
                return 'The value exceeds existences.'
            }

            return true
        },
        setAllAvailableAsReleased() {
            this.items.forEach(item => {
                if (this.setAvailableAsReleased) {
                    item.releaseQty = Number(item.pendingQty)
                    delete item.rejectQty
                    delete item.reprocessQty
                } else {
                    delete item.releaseQty
                }
            })
        },
        verifyCheckBox() {
            this.setAvailableAsReleased = !this.items.some(
                item => (item.releaseQty || 0) < item.pendingQty
            )
        },
        getNCCode(id) {
            let code = { code: id, type: id, description: id }
            const foundCode = this.ncCodes.find(c => c.id == id)
            if (foundCode) {
                code = foundCode
            }
            return code.code
        },
    },
}
</script>

<style></style>
